import React from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { Message } from 'primereact/message';
import { connect } from "react-redux";
import Server from "./Server.js";
import { Toast } from "primereact/toast";
import "./Login.css";
import Footer from "./Footer.js";
import { InputText } from 'primereact/inputtext';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.state = {
      logo: "",
      inputEmail: "",
      inputPassword: "",
      articles: [],
      name: "",
      AutenticatedUser: false,
      AutenticatedAdmin: false,
      HasError: false,
      loginState: true,
      ActiveSms: "none",
      AccessAfterReg: 0,
      STitle: "",
      registerState: false,
      changePassState: false,
      SmsToken: null,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      Step: 0,
      url: this.Server.getUrl(),
      systemId: this.Server.getSystem()
    };
    this.toast = React.createRef();

    this.handleChangeinputEmail = this.handleChangeinputEmail.bind(this);
    this.get = this.get.bind(this);
    this.getPassword = this.getPassword.bind(this);
    this.getNewPass = this.getNewPass.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
    this.handleChangeinputPassword = this.handleChangeinputPassword.bind(this);
    this.handleChangeSecurityCode = this.handleChangeSecurityCode.bind(this);
    this.saveNotifSubscriber = this.saveNotifSubscriber.bind(this);

  }
  async saveNotifSubscriber(username){
    let that= this;
    const publicKey = 'BE6ZH82CAm1cQ-L4PHdTpO5YkL-sZCOH-_Tm2HTAwn8ZhcIYX_gOdzBhk5qT1YK0_r3tczDbYfM0TxUqpQRmIDk';
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    const register = await navigator.serviceWorker.register(swUrl,{
      scop:'/'
    });
    const subscription = await register.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey:publicKey
    }).then(async function(subscription) {
      that.Server.send("AdminApi/saveSubscriber", {body:JSON.stringify(subscription),username:username}, (response)=>{
          console.log('save subscriber ...')
      }, ()=>{
      });
    })
  }

  componentDidMount() {
    this.Server.send("MainApi/getSystems", { _id: this.state.systemId }, (response)=>{
      this.setState({
        logo: response.data.result[0].logo
      })
      this.getSetting();
    }, ()=>{
      this.getSetting();
    });

  }

  createSystemOfUser(){
    this.Server.send("MainApi/createSystemOfUsers", {  }, (response)=>{
     
    }, ()=>{
    });
  }
  getSetting() {
    let that = this;
    axios
      .post(this.state.url + "getSettings", {
        token: localStorage.getItem("api_token"),
      })
      .then((response) => {
        that.setState({
          ActiveSms: response.data.result
            ? response.data.result.ActiveSms
            : "none",
          STitle: response.data.result ? response.data.result.STitle : "",
          AccessAfterReg: response.data.result
            ? response.data.result.AccessAfterReg
            : 0,
          RegSmsText: response.data.result
            ? response.data.result.RegSmsText
            : "",
          RegisterByMob: response.data.result
            ? response.data.result.RegisterByMob
            : false,
          System: response.data.result ? response.data.result.System : "shop",
          AllowRegister: response.data.result
            ? response.data.result.AllowRegister
            : false,
          Theme: response.data.result ? response.data.result.Theme : "1",
        });
        if (response.data.result.System == "company") {
          that.GetShopList();
          return false;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  GetShopList() {
    let that = this;

    let param = {
      condition: { Registerable: true },
    };
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        shopId: response.data.result[0] ? response.data.result[0]._id : null,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.GetProduct();
    };
    this.Server.send("AdminApi/ShopInformation", param, SCallBack, ECallBack);
  }
  goToLogin() {
    this.setState({
      loginState: true,
      changePassState: false,
    });
  }
  getPassword() {
    this.setState({
      Step: -1,
    });
  }

  getNewPass() {
    if (!this.state.inputEmail || this.state.inputEmail == "") {
      this.toast.current.show({
        severity: "error",
        summary: <div> شماره تلفن همراه نمی تواند خالی باشد</div>,
        life: 8000,
      });
      return;
    }
    axios
      .post(this.state.url + "GetNewPass", {
        username: this.state.inputEmail,
      })
      .then((response) => {
        var text = response.data.result;
        if (isNaN(text)) {
          this.setState({
            HasError: text,
          });
          return;
        }
        if (this.state.ActiveSms == "none") return;
          axios
            .post(this.state.url + "sendSms", {
              token: response.data.result.TokenKey,
              text:
                "رمز عبور جدید شما  : \n" +
                text +
                "\n در اولین فرصت رمز عبور خود را تغییر دهید" +
                "\n" +
                this.state.STitle,
              mobile: this.state.inputEmail,

            })
            .then((response) => {
              this.toast.current.show({
                severity: "success",
                summary: <div> پیامک رمز جدید ارسال شد</div>,
                life: 8000,
              });
              this.setState({
                Step: 0,
                inputPassword: "",
              });
            })
            .catch((error) => {});
        /*axios.post('https://RestfulSms.com/api/Token', {})
            .then(response => {
                  
                  this.setState({
                    SmsToken:response.data.TokenKey
                  })
                  axios.post(this.state.url+'sendsms_SmsIr', {
                    token: response.data.TokenKey,
                    text: "رمز عبور جدید شما در سامانه ی فروشگاهی سرو : \n"+text+"\n در اولین فرصت رمز عبور خود را تغییر دهید",
                    mobileNo : this.state.inputEmail
                  })
                  .then(response => {
                      alert(response)
                  
                  })
                  .catch(error => {
                   // alert(error);
                    console.log(error)
                  })
              
              
            })
            .catch(error => {
              alert(error);
              console.log(error)
            })
        */
      })
      .catch((error) => {
        alert(error);
        console.log(error);
      });
  }
  Register(final) {
    if (!this.state.inputEmail || this.state.inputEmail == "") {
      this.toast.current.show({
        severity: "error",
        summary: <div> شماره تلفن همراه نمی تواند خالی باشد</div>,
        life: 8000,
      });
      this.setState({
        Step: 0,
      });
      return;
    }
    if (this.state.Step == 2) {
      if (!this.state.RegisterByMob) {
        this.setState({
          registerState: true,
        });
        return;
      }
      axios
        .post(this.state.url + "Register", {
          username: this.state.inputEmail.trim(),
          Step: "1",
          level: this.state.System == "company" ? "1" : "0",
          map: this.state.System == "company" ? "کارمند سیستم" : null,
          AccessAfterReg: this.state.AccessAfterReg,
        })
        .then((response) => {
          var SecCode = response.data.SecurityCode;

          if (this.state.ActiveSms == "smart") {
            axios
              .post(this.state.url + "sendsms_smartSms", {
                token: response.data.result.TokenKey,
                text: this.state.AccessAfterReg
                  ? "کد ثبت نام : " +
                    SecCode +
                    "\n" +
                    "این کد به عنوان رمز عبور شما در سیستم تعریف می شود" +
                    "\n" +
                    this.state.STitle
                  : this.state.RegSmsText +
                    "\n" +
                    "این کد به عنوان رمز عبور شما در سیستم تعریف می شود" +
                    "\n" +
                    "کد پیگیری ثبت نام : " +
                    SecCode +
                    "\n" +
                    this.state.STitle,
                mobileNo: this.state.inputEmail.trim(),
              })
              .then((response) => {
                console.log(response);
              })
              .catch((error) => {});
          } else if (this.state.ActiveSms == "smsir") {
            axios
              .post(this.state.url + "GetSmsToken", {})
              .then((response) => {
                this.setState({
                  SmsToken: response.data.result.TokenKey,
                });
                axios
                  .post(this.state.url + "sendsms_SmsIr", {
                    token: response.data.result.TokenKey,
                    text: this.state.AccessAfterReg
                      ? "کد  ثبت نام : " +
                        SecCode +
                        "\n" +
                        "این کد به عنوان رمز عبور شما در سیستم تعریف می شود" +
                        "\n" +
                        this.state.STitle
                      : this.state.RegSmsText +
                        "\n" +
                        "کد پیگیری ثبت نام : " +
                        SecCode +
                        "\n" +
                        "این کد به عنوان رمز عبور شما در سیستم تعریف می شود" +
                        "\n" +
                        this.state.STitle,
                    mobileNo: this.state.inputEmail.trim(),
                  })
                  .then((response) => {
                    console.log(response);
                  })
                  .catch((error) => {
                    // alert(error);
                    alert(error);
                  });
              })
              .catch((error) => {
                alert(error);
                console.log(error);
              });
          }
        })
        .catch((error) => {
          alert(error);
          console.log(error);
        });
    }
    if (this.state.Step == 3) {
      axios
        .post(this.state.url + "Register", {
          username: this.state.inputEmail,
          password: this.state.SecurityCode,
          SecurityCode: this.state.SecurityCode,
          level: this.state.System == "company" ? "1" : "0",
          map: this.state.System == "company" ? "کارمند سیستم" : null,
          shopId: this.state.System == "company" ? this.state.shopId : null,
          Step: "2",
        })
        .then((response) => {
          if (response.data.msg) {
            this.setState({
              Step: 2,
              HasError: response.data.msg,
            });
            return;
          }
          axios
            .post(this.state.url + "Register", {
              username: this.state.inputEmail,
              password: this.state.SecurityCode,
              level: this.state.System == "company" ? "1" : "0",
              map: this.state.System == "company" ? "کارمند سیستم" : null,
              Step: "3",
            })
            .then((response) => {
              if (this.state.ActiveSms == "smart") {
                axios
                  .post(this.state.url + "sendsms_smartSms", {
                    token: response.data.result.TokenKey,
                    text: this.state.RegSmsText + "\n" + this.state.STitle,
                    mobileNo: this.state.inputEmail.trim(),
                  })
                  .then((response) => {
                    console.log(response);
                  })
                  .catch((error) => {});
              } else if (this.state.ActiveSms == "smsir") {
                axios
                  .post(this.state.url + "GetSmsToken", {})
                  .then((response) => {
                    this.setState({
                      SmsToken: response.data.result.TokenKey,
                    });
                    axios
                      .post(this.state.url + "sendsms_SmsIr", {
                        token: response.data.result.TokenKey,
                        text: this.state.RegSmsText + "\n" + this.state.STitle,
                        mobileNo: this.state.inputEmail.trim(),
                      })
                      .then((response) => {
                        console.log(response);
                      })
                      .catch((error) => {
                        // alert(error);
                        alert(error);
                      });
                  })
                  .catch((error) => {
                    alert(error);
                    console.log(error);
                  });
              }

              localStorage.setItem("api_token", response.data.token);
              this.props.dispatch({
                type: "LoginTrueUser",
                systemId : response.data.result[0].systemId
              });
              if (response.data.result[0].level == "0")
                this.setState({
                  AutenticatedUser: true,
                });
              else
                this.setState({
                  AutenticatedAdmin: true,
                });
            })
            .catch((error) => {
              alert(error);
              console.log(error);
            });
        })
        .catch((error) => {
          alert(error);
          console.log(error);
        });
    }
  }
  get() {
    if (this.state.Step == "-1") {
      this.getNewPass();
      return;
    }
    this.setState({
      HasError: false,
    });
    if (!this.state.inputPassword && this.state.Step != 2) {
      axios
        .post(this.state.url + "getuser", {
          username: this.state.inputEmail,
          systemId : this.state.systemId
        })
        .then((response) => {
          if (response.data.result == "no") {
            if (this.state.System == "shop" || this.state.AllowRegister) {
              this.setState({
                Step: 2,
              });
              this.Register();
            } else {
              this.setState({
                HasError: "نام کاربری نادرست است",
              });
            }
          } else {
            this.setState({
              Step: 1,
            });
          }
        })
        .catch((error) => {
          if (this.state.System == "shop") {
            this.setState({
              Step: 2,
            });
            this.Register();
            console.log(error);
          }
        });

      return;
    } else if (this.state.Step == 2) {
      if (this.state.SecurityCode == "") {
        this.setState({
          HasError: "کد امنیتی پیامک شده را وارد کنید",
        });
        return;
      }
      this.setState({
        Step: 3,
      });
      let that = this;
      setTimeout(function () {
        that.Register();
      }, 0);
      return;
    }
    axios
      .post(this.state.url + "getuser", {
        username: this.state.inputEmail,
        password: this.state.inputPassword,
        systemId : this.state.systemId
      })
      .then((response) => {
        if (!response.data.token) {
          this.setState({
            HasError: response.data.result[0],
          });
          return;
        }
        this.setState({
          name: response.data.result[0].name,
        });
        localStorage.setItem("api_token", response.data.token);
        localStorage.setItem("systemId", this.state.systemId);

        this.props.dispatch({
          type: "LoginTrueUser",
          systemId: this.state.systemId
        });
        if (response.data.result[0].level == "0")
          this.setState({
            AutenticatedUser: true,
          });
        else
          this.setState({
            AutenticatedAdmin: true,
          });

          this.saveNotifSubscriber(this.state.inputEmail);  
      })
      .catch((error) => {
        this.setState({
          HasError: "رمز عبور اشتباه است",
        });
        console.log(error);
      });
  }
  handleChangeinputEmail(event) {
    this.setState({ inputEmail: event.target.value });
  }
  handleChangeinputPassword(event) {
    this.setState({ inputPassword: event.target.value });
  }
  handleChangeSecurityCode(event) {
    this.setState({ SecurityCode: event.target.value });
  }
  render() {
    if (this.state.registerState) {
      return <Navigate to="/Register" Mobile={this.state.mobileNo} />;
    }
    if (this.state.AutenticatedUser == true) {
      return (
        <Navigate to="/MainShop" Autenticated={this.state.AutenticatedUser} />
      );
    }
    if (this.state.AutenticatedAdmin == true) {
      return (
        <Navigate
          to="/admin/admin"
          Autenticated={this.state.AutenticatedAdmin}
        />
      );
    }
    if (!this.state.changePassState && this.state.loginState) {
      return (
        <div>
          {this.state.Theme != null ? (
            <div
              className="mt-lg-5 mt-2"
              style={{
                direction: "rtl",
                minHeight: !this.props.noHeader ? 600 : "auto",
              }}
            >
              <div className="row">
                <div
                  className="col-sm-10 col-12 col-md-9 col-lg-12 mt-3"
                  style={{ position: "relative" }}
                >
                  <Toast
                    ref={this.toast}
                    position="bottom-left"
                    style={{
                      fontFamily: "YekanBakhFaBold",
                      textAlign: "right",
                    }}
                  />

                  <div
                    style={{ padding: 30}}
                  >
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "spaceBetween",
                        }}
                      >
                        <div>
                          {this.state.Step != 0 && (
                            <i
                              className="fal fa-arrow-circle-right"
                              style={{ cursor: "pointer", fontSize: 28 }}
                              onClick={() => {
                                this.setState({
                                  Step: 0,
                                  inputPassword: "",
                                  HasError: 0,
                                });
                              }}
                            />
                          )}
                        </div>
                        <div></div>
                      </div>
                              {this.state.logo &&
                                <div style={{display:'flex',justifyContent:'center'}}>
                                <img src={this.state.logo} style={{maxHeight:100}} />      
                                </div>
                              }
                            
                        <div>
                          <div  style={{ marginTop: 45, display:'flex', justifyContent:'center' }}>
                          <div style={{textAlign:'center',position:'relative',maxWidth:400, width:'100%'}}> 

                          <InputText value={this.state.inputEmail} onChange={this.handleChangeinputEmail} placeholder="شماره موبایل"
                            style={{width:'100%', textAlign:'center'}}
                          />
                          <Avatar icon={<i className="pi pi-user-plus" />} className="avatar-sarv" size="xlarge" shape="circle" style={{position:'absolute',left:-18,top:-8}}/>

                              </div>
                          </div>
                        </div>
                        {this.state.Step != -1 &&
                        <div style={{ marginTop: 30, display:'flex', justifyContent:'center' }}>
                        <div style={{textAlign:'center',position:'relative',maxWidth:400, width:'100%'}}> 
                         <Password feedback={false} style={{width:'100%'}} inputStyle={{ textAlign:'center'}} value={this.state.inputPassword} onChange={this.handleChangeinputPassword}  placeholder="رمز عبور"
                          
                        />
                        <Avatar icon={<i className="pi pi-key rotate" />} className="avatar-sarv" size="xlarge" shape="circle" style={{position:'absolute',left:-18,top:-8}}/>
                        </div>

                      </div>
                        }
                        

                      {this.state.Step == "2" && (
                        <div className="group">
                          <input
                            className="form-control YekanBakhFaBold"
                            style={{ textAlign: "center" }}
                            type="text"
                            id="SecurityCode"
                            value={this.state.SecurityCode}
                            name="SecurityCode"
                            onChange={this.handleChangeSecurityCode}
                            required
                          />
                          <label className="YekanBakhFaBold">کد تایید </label>
                        </div>
                      )}
                      <div style={{ width: "100%",textAlign:'center',marginTop:30 }}>
                        <Button label={this.state.Step != -1 ? "ورود" : "دریافت رمز با پیامک"} onClick={this.get} className="p-button-raised p-button-rounded button-main-sarv" />

                      </div>
                      {this.state.Step != -1 &&
                       <div style={{ width: "100%",textAlign:'center',marginTop:30 }}>
                       <Button  label="فراموشی رمز عبور" onClick={()=>{
                         this.setState({
                           Step: -1
                         })
                       }} className="p-button-text button-text-sarv" />

                      <Button  label="create systemofuser" style={{display: "none"}} onClick={()=>{
                         this.createSystemOfUser();
                       }} className="p-button-text button-text-sarv" />


                     </div>
                      }
                     
                      {this.state.Step == "2" && (
                        <div style={{ textAlign: "center" }}>
                          <label className="YekanBakhFaBold">
                            تا چند ثانیه دیگر کد تایید به شماره موبایل شما پیامک
                            خواهد شد
                          </label>
                        </div>
                      )}
                    </div>
                    {this.state.HasError ? (
                        <div style={{display:'flex',justifyContent:'center',marginTop:30}} >
                              <Message severity="error" text={this.state.HasError} />
                        </div>
                      
                    ) : (
                      <p></p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          {!this.props.noFooter && this.state.Theme != null && <Footer />}
        </div>
      );
    }
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Login);
